// src/state/tableLayout/types.ts
var Shapes = /* @__PURE__ */ ((Shapes2) => {
  Shapes2["SQUARE"] = "square";
  Shapes2["CUSTOM"] = "custom";
  Shapes2["CIRCLE"] = "circle";
  Shapes2["RECTANGLE"] = "rectangle";
  return Shapes2;
})(Shapes || {});
var ElementTypes = /* @__PURE__ */ ((ElementTypes2) => {
  ElementTypes2["TABLE"] = "table";
  ElementTypes2["PLANT"] = "plant";
  ElementTypes2["DOOR"] = "door";
  ElementTypes2["WINDOW"] = "window";
  ElementTypes2["STATION"] = "station";
  ElementTypes2["WALL"] = "wall";
  ElementTypes2["CUSTOM"] = "custom";
  return ElementTypes2;
})(ElementTypes || {});
var UndoRedoAction = /* @__PURE__ */ ((UndoRedoAction2) => {
  UndoRedoAction2["REMOVE"] = "remove";
  UndoRedoAction2["ADD"] = "add";
  UndoRedoAction2["EDIT"] = "edit";
  return UndoRedoAction2;
})(UndoRedoAction || {});
var TableStatuses = /* @__PURE__ */ ((TableStatuses2) => {
  TableStatuses2["UNAVAILABLE"] = "unavailable";
  TableStatuses2["AVAILABLE"] = "available";
  TableStatuses2["SEATED"] = "seated";
  TableStatuses2["ORDERED"] = "ordered";
  TableStatuses2["TIP_PENDING"] = "tip-pending";
  TableStatuses2["CLEANING"] = "cleaning";
  return TableStatuses2;
})(TableStatuses || {});
var TableActions = /* @__PURE__ */ ((TableActions2) => {
  TableActions2["MERGE"] = "merge";
  TableActions2["UNMERGE"] = "unmerge";
  TableActions2["PAY"] = "pay";
  TableActions2["PRINT_CHECK"] = "payCheck";
  TableActions2["MOVE"] = "move";
  TableActions2["ORDER"] = "order";
  TableActions2["TRANSFER"] = "transfer";
  TableActions2["SET_AVAILABLE"] = "setAvailable";
  TableActions2["DRAG_DROP"] = "dragDrop";
  TableActions2["ASSIGN_TABLE"] = "assignTable";
  TableActions2["UNASSIGN_TABLE"] = "unassignTable";
  TableActions2["JOIN_ORDERS"] = "joinOrders";
  TableActions2["PICK_TABLE_FOR_NEW_ORDER"] = "pickTableForNewOrder";
  return TableActions2;
})(TableActions || {});
var ignoredFieldsToSave = ["name", "seats"];
var SET_TABLE_LAYOUT_DATA = "SET_TABLE_LAYOUT_DATA";
var SET_SAVE_LAYOUT_CHANGES = "SET_SAVE_LAYOUT_CHANGES";
var SET_CURRENT_EDIT_DATA = "SET_CURRENT_EDIT_DATA";
var RESET_CURRENT_EDIT_DATA = "RESET_CURRENT_EDIT_DATA";
var DISCARD_TABLE_LAYOUT_CHANGES = "DISCARD_TABLE_LAYOUT_CHANGES";
var SET_SELECTED_ELEMENT = "SET_SELECTED_ELEMENT";
var SET_SELECTED_TABLES = "SET_SELECTED_TABLES";
var SET_SELECTED_ACTION = "SET_SELECTED_ACTION";
var SET_SERVICE_AREA = "SET_SERVICE_AREA";
var SET_ORDER_TYPE = "SET_ORDER_TYPE";
var SET_TOOL_SETTINGS = "SET_TOOL_SETTINGS";
var UPDATE_TABLE_LAYOUT_STORE = "UPDATE_TABLE_LAYOUT_STORE";
var SET_SELECTED_LAYOUT = "SET_SELECTED_LAYOUT";
var SET_NEW_SERVICE_AREA = "SET_NEW_SERVICE_AREA";
var UPDATE_SERVICE_AREA = "UPDATE_SERVICE_AREA";
var REMOVE_SERVICE_AREA = "REMOVE_SERVICE_AREA";
var UPDATE_SERVICE_AREAS = "UPDATE_SERVICE_AREAS";
var SET_LAST_SERVICE_AREAS_ORDER = "SET_LAST_SERVICE_AREAS_ORDER";
var SET_LAST_UNDO_CHANGES = "SET_LAST_UNDO_CHANGES";
var SET_LAST_REDO_CHANGES = "SET_LAST_REDO_CHANGES";
var SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA = "SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA";
var SET_IS_BOTTOM_SHEET_OPEN = "SET_IS_BOTTOM_SHEET_OPEN";
var INITIALIZE_TABLES_LAYOUT = "INITIALIZE_TABLES_LAYOUT";
var INITIALIZE_LAYOUT = "INITIALIZE_LAYOUT";
var UPDATE_TABLES = "UPDATE_TABLES";
var UPDATE_TABLES_WS = "UPDATE_TABLES_WS";
var UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE = "UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE";
var UPDATE_TABLE_LAYOUT_AND_ORDERS = "UPDATE_TABLE_LAYOUT_AND_ORDERS";
var UPDATE_SINGLE_TABLE_WS = "UPDATE_SINGLE_TABLE_WS";

export { DISCARD_TABLE_LAYOUT_CHANGES, ElementTypes, INITIALIZE_LAYOUT, INITIALIZE_TABLES_LAYOUT, REMOVE_SERVICE_AREA, RESET_CURRENT_EDIT_DATA, SET_CURRENT_EDIT_DATA, SET_IS_BOTTOM_SHEET_OPEN, SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA, SET_LAST_REDO_CHANGES, SET_LAST_SERVICE_AREAS_ORDER, SET_LAST_UNDO_CHANGES, SET_NEW_SERVICE_AREA, SET_ORDER_TYPE, SET_SAVE_LAYOUT_CHANGES, SET_SELECTED_ACTION, SET_SELECTED_ELEMENT, SET_SELECTED_LAYOUT, SET_SELECTED_TABLES, SET_SERVICE_AREA, SET_TABLE_LAYOUT_DATA, SET_TOOL_SETTINGS, Shapes, TableActions, TableStatuses, UPDATE_SERVICE_AREA, UPDATE_SERVICE_AREAS, UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE, UPDATE_SINGLE_TABLE_WS, UPDATE_TABLES, UPDATE_TABLES_WS, UPDATE_TABLE_LAYOUT_AND_ORDERS, UPDATE_TABLE_LAYOUT_STORE, UndoRedoAction, ignoredFieldsToSave };
